import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {EnumStoredService, ENUM} from 'src/app/core/services/enum.service';
import {
    Constant,
    RequireTypeFile
} from 'src/app/core/helper/validator-custom/ValidatorCustom';
import {environment} from 'src/environments/environment';
import {CATALOG_ITEM, ROLE_LIST, URL_IMAGE_PREV} from 'src/app/core/common/constant';
import {CandidateAddOtherItemComponent} from '../../../recruitment/candidate/candidate-add-other-item/candidate-add-other-item.component';
import {CatalogItemModel} from '../../../../core/models/catalog.item.model';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {AddStorageProfileModalComponent} from '../add-storage-profile-modal/add-storage-profile-modal.component';
import {EmployeeService} from '../../../../core';

declare const $: any;

@Component({
    selector: 'app-storage-profile-modal',
    templateUrl: './storage-profile-modal.component.html',
    styleUrls: ['./storage-profile-modal.component.css'],
})
export class StorageProfileModalComponent implements OnInit {
    public storageProfileForm: FormGroup;
    value: any = '';
    employee;
    @Output() onSubmit = new EventEmitter<any>();
    @Output() onClose = new EventEmitter<any>();
    public isDisabled: Boolean = false;
    public textPattern = Constant.NAME_RULE;
    public AVATAR_DEFAULT: any = 'assets/img/profiles/avatar-2.jpg';
    public avatarBase64: any = 'assets/img/profiles/avatar-2.jpg';
    public roleCandidates: any = [];
    public stackCandidates: any = [];
    public stackLevelCandidates = [];
    public imageUrl = environment.imageUrl + '/download-file';
    public domainUrl = URL_IMAGE_PREV.url;
    public maxLength: number = 37;

    public listCv: any[] = [];
    public listCvShow: any[] = [];
    public listIdDeleteFile: any[] = [];
    additionalFile = new Map();
    listCatalogFile = ['profileFile', 'cvFile', 'cvEnFile', 'sylsFile', 'graduateDegreeFile', 'identityFrontSideFile', 'identityBackSideFile', 'certificateFile', 'socialInsuranceFile', 'avatarFile', 'dependentPersonFile', 'checkInFile']
    invalidFile = [];
    constructor(
        private toastr: ToastrService,
        private formBuilder: FormBuilder,
        private enumService: EnumStoredService,
        private modalService: BsModalService,
        private employeeService: EmployeeService,
        public bsModalRef: BsModalRef,
    ) {
    }

    ngOnInit() {
        this.loadData();
    }

    setDefaultValue(value: any = null) {
        this.storageProfileForm = this.formBuilder.group({
            id: value?.id ? value.id : null,
            profileFile: ['', [RequireTypeFile.maxSizeFile(5)]],// cv Tiếng anh
            cvFile: ['', [RequireTypeFile.maxSizeFile(5)]],// cv Tiếng anh
            cvEnFile: ['', [RequireTypeFile.maxSizeFile(5)]],// cv Tiếng anh
            sylsFile: ['', [RequireTypeFile.maxSizeFile(5)]],// sơ yếu lý lịch
            graduateDegreeFile: ['', [RequireTypeFile.maxSizeFile(5)]],// bằng tốt nghiệp
            // identityFile: [ "", [...this.getValidateRequire('identityFile', value), RequireTypeFile.maxSizeFile(5), RequireTypeFile.typeFile(this.typeFiles, true)]],// cccd
            identityFrontSideFile: ['', [RequireTypeFile.maxSizeFile(5)]],// anh mat truoc
            identityBackSideFile: ['', [RequireTypeFile.maxSizeFile(5)]],// anh mat sau
            certificateFile: ['', [RequireTypeFile.maxSizeFile(5, true)]],// chứng chỉ
            socialInsuranceFile: ['', [RequireTypeFile.maxSizeFile(5)]],// Sổ bảo hiểm
            avatarFile: ['', [RequireTypeFile.maxSizeFile(5)]],// Sổ bảo hiểm
            dependentPersonFile: ['', [RequireTypeFile.maxSizeFile(5, true)]],// Hồ sơ người phụ thuộc
            checkInFile: ['', [RequireTypeFile.maxSizeFile(5, true), RequireTypeFile.typeFile()]],// Ảnh check in
        });
        if (value) {
            this.createAdditionalFile(value);
        }
    }

    private createAdditionalFile(value: any) {
        this.additionalFile = new Map();
        for (let i = 0; i < value.length; i++) {
            if (!this.listCatalogFile.includes(value[i].catalogName)) {
                if (this.additionalFile.has(value[i].catalogName)) {
                    if (value[i].fileId) {
                        this.additionalFile.get(value[i].catalogName).push(value[i])
                    }
                } else {
                    this.additionalFile.set(value[i].catalogName, value[i].fileId ? [value[i]] : [])
                }
            }
        }
    }

    loadData() {
        this.setDefaultValue(this.value);
    }

    onClickButtonSave() {
        this.storageProfileForm.markAllAsTouched();
        if (this.storageProfileForm.valid && this.invalidFile.length === 0) {
            this.onSubmit.emit({
                ...this.storageProfileForm.value,
                additionalFile: this.additionalFile,
                listIdDeleteFile: this.listIdDeleteFile,
            });
        }

    }

    getListFile(key: string) {
        let list: any = [];
        for (let index = this.value?.length - 1; index >= 0; index--) {
            if (this.listIdDeleteFile.indexOf(this.value[index].id) >= 0) {
                continue;
            }
            if (this.value[index]?.catalogName == key) {
                const finder = this.value[index];
                if (finder) {
                    let filePathList = finder.filePath.split('/');
                    finder.fileName = filePathList[filePathList?.length - 1];
                }
                list.push(finder);
            }
        }
        return list;
    }

    removeFileAt(id: number = 0, key: string = '') {
        if (key) {
            let formArray = Array.from(this.storageProfileForm.controls[key].value);
            formArray.splice(id, 1);
            this.storageProfileForm.controls[key].patchValue(formArray);
        } else {
            this.listIdDeleteFile.push(id);
        }
    }

    getFileName(key: string) {
        let finder = null;
        for (let index = this.value?.length - 1; index >= 0; index--) {
            if (this.value[index]?.catalogName == key) {
                finder = this.value[index];
                break;
            }
        }
        if (finder) {
            let filePathList = finder.filePath.split('/');
            return filePathList[filePathList?.length - 1];
        }
        return '';
    }

    getFilePath(catalogName: string) {
        let finder = null;
        for (let index = this.value?.length - 1; index >= 0; index--) {
            if (this.value[index]?.catalogName == catalogName) {
                finder = this.value[index];
                break;
            }
        }
        if (finder) {
            return finder.fileId;
        }
        return '';
    }

    addNewCatalog() {
        let modalRef = this.modalService.show(AddStorageProfileModalComponent, {
            initialState: {
                employee: this.employee
            },
            class: 'modal-left modal-dialog-centered w-50 max-width-modal expand',
            ignoreBackdropClick: true,
        });

        if (modalRef) {
            (<AddStorageProfileModalComponent>modalRef.content).addOtherItemIdSuccess.subscribe((res) => {
                this.employeeService.findById(this.employee.id).subscribe({
                    next: (data: any) => {
                        for (let catalog of data?.data.catalogStoreds) {
                            if (this.value.filter(file => file.id === catalog.id).length === 0) {
                                this.value.push(catalog);
                            }
                        }
                        this.createAdditionalFile(this.value);
                    }
                });
            });
        }
    }

    closeModal() {
        this.bsModalRef.hide();
    }

    uploadFile(event: any, key, value) {
        let fileList = event.target.files as FileList;
        for (let i = 0; i < fileList.length; i++) {
            let file = fileList.item(i);
            if (file.size && file.size > 1024 * 1024 * 5) {
                if (!this.invalidFile.includes(key)) {
                    this.invalidFile.push(key);
                }
            }
            value.push({
                file: file,
                fileName: file.name
            })
        }
    }

    removeAdditionalFileContent(key, value, fileContent) {
        value = value.filter(file => file !== fileContent);
        this.additionalFile.set(key, value);
        for (let i = 0; i < value.length; i++) {
            let file = value[i];
            if (file.size && file.size > 1024 * 1024 * 5) {
                if (!this.invalidFile.includes(key)) {
                    this.invalidFile.push(key);
                }
                return;
            }
        }
        if (this.invalidFile.includes(key)) {
            this.invalidFile = this.invalidFile.filter(invalid => invalid !== key);
        }

        if (!fileContent.file?.size) {
            this.listIdDeleteFile.push(fileContent.id);
        }
    }

    removeAdditionalFile(key, value) {
        this.additionalFile.delete(key);
        for (let i = 0; i < this.value.length; i++) {
            let file = this.value[i];
            if (file.catalogName === key) {
                this.listIdDeleteFile.push(file.id);
            }
        }
        if (this.invalidFile.includes(key)) {
            this.invalidFile = this.invalidFile.filter(invalid => invalid !== key);
        }
    }

    getFileNameAdditional(file: any) {
        if (!file) return '';
        if (file.fileName) {
            return file.fileName;
        }
        let filePath = file.filePath;
        if (!filePath) return '';
        let filePathList = filePath.split('/');
        return filePathList[filePathList?.length - 1];
    }

    viewFile(file) {
        window.open(this.domainUrl + file.fileId, "_blank");
    }
}
